(function ($) {
    'use strict';

    /**
     * Список вопросов тренеру
     * @returns {jQuery}
     */
    $.fn.trainerQuestions = function () {
        var $self = $(this);
        var $list = $self.find('.js-question-list');
        var ajaxUrl = $self.data('url');
        var voteUrl = $self.data('vote-url');
        var pageSize = typeof $self.data('page-size') !== 'undefined' ? parseInt($self.data('page-size')) : 10;

        /**
         * Получить текущую сортировку в текстовом виде
         * @returns {string}
         */
        function getSort () {
            var $sortSwitch = $self.find('.js-sort-switch');
            if ($sortSwitch.length && typeof $sortSwitch.data('sortSwitch') !== 'undefined') {
                return $sortSwitch.data('sortSwitch').getState() ? 'popular' : 'new';
            }
        }

        function goToPage (pageNumber) {
            loadQuestions({
                sort: getSort(),
                page: pageNumber,
                limit: pageSize
            });

            window.scroll({
                top: $self.offset().top,
                behavior: 'smooth'
            });
        }

        /**
         * Получить список вопросов с сервера
         * @param {Object} [params] - параметры запроса для получения списка
         * @param {String} [params.sort=new] - тип сортировки
         * @param {Number} [params.page=1] - номер страницы для вывода
         * @param {Number} [params.limit=10] - количество элементов на странице
         */
        function loadQuestions (params) {
            $.ajax({
                url: ajaxUrl,
                type: 'get',
                data: params
            }).done(
                /**
                 * Обработка результата запроса на получение списка новостей
                 * @param {Object} result - результат запроса
                 * @param {String} result.html - список вопросов в виде HTML
                 * @param {Number} result.current_page - текущая страница
                 * @param {Number} result.pages_count - количество страниц
                 */
                function(result) {
                    if (result.pages_count) {
                        $self.removeClass('hide');
                        $list.html(result.html);

                        if (result.pages_count > 1) {
                            var $pagination = $('<div>', {
                                class: 'pagination hide-desktop',
                                append: [
                                    $('<button>', {
                                        type: 'button',
                                        class: 'pagination-item page-first',
                                        disabled: result.current_page === 1,
                                        on: {
                                            click: function () {
                                                goToPage(1);
                                            }
                                        }
                                    }),
                                    $('<button>', {
                                        type: 'button',
                                        class: 'pagination-item page-prev',
                                        disabled: result.current_page === 1,
                                        on: {
                                            click: function () {
                                                goToPage(result.current_page - 1);
                                            }
                                        }
                                    }),
                                    $('<div>', {
                                        class: 'pagination-item page-current',
                                        append: [
                                            $('<span>', {
                                                text: result.current_page
                                            }),
                                            (' / ' + result.pages_count)
                                        ]
                                    }),
                                    $('<button>', {
                                        type: 'button',
                                        class: 'pagination-item page-next',
                                        disabled: result.current_page === result.pages_count,
                                        on: {
                                            click: function () {
                                                goToPage(result.current_page + 1);
                                            }
                                        }
                                    }),
                                    $('<button>', {
                                        type: 'button',
                                        class: 'pagination-item page-last',
                                        disabled: result.current_page === result.pages_count,
                                        on: {
                                            click: function () {
                                                goToPage(result.pages_count);
                                            }
                                        }
                                    })
                                ]
                            });
                            $pagination.wrapInner($('<div>', {
                                class: 'pagination-wrap'
                            }));
                            $pagination.appendTo($list);
                        }

                        var $questionContent = $list.find('.js-question-content');
                        $questionContent.each(function () {
                            var $content = $(this);
                            var maxLines = parseInt($content.data('maxLines'));
                            var lineHeight = parseFloat($content.css('line-height'));

                            if ($content.height() >= maxLines * lineHeight) {
                                $content.wrapInner($('<div>', {
                                    class: 'question-content-wrap',
                                    css: {
                                        maxHeight: maxLines * lineHeight,
                                        minHeight: maxLines * lineHeight,
                                        overflow: 'hidden'
                                    }
                                }));

                                var $contentWrap = $content.children();
                                var $contentToggle = $('<button>', {
                                    type: 'button',
                                    class: 'question-content-btn',
                                    text: $content.data('text-expand')
                                });
                                $content.append($contentToggle);

                                $contentToggle.on('click', function () {
                                    $contentWrap
                                        .toggleClass('open')
                                        .css({
                                            minHeight: $contentWrap.hasClass('open') ?
                                                $contentWrap.get(0).scrollHeight :
                                                (maxLines * lineHeight)
                                        });
                                    $contentToggle.text(
                                        $contentWrap.hasClass('open') ?
                                            $content.data('text-collapse') :
                                            $content.data('text-expand')
                                    ).blur();
                                });
                            }
                        });
                    } else {
                        $self.addClass('hide');
                    }
                }
            ).fail(function(err) {
                console.log('Не удалось получить список вопросов', err);
            });
        }

        /**
         * Инициализация
         */
        function init () {
            loadQuestions({
                page: 1,
                sort: 'new',
                limit: pageSize
            });

            // Изменение сортировки
            $self.on('sortSwitch', function (e, param) {
                var newSort = param.state ? 'popular' : 'new';
                loadQuestions({
                    page: 1,
                    sort: newSort,
                    limit: pageSize
                });
            });

            // Клик по кнопке "проголосовать"
            $(document).on('click', '.js-question-vote', function (e) {
                e.preventDefault();
                var $btn = $(this);
                if (!$btn.data('user-vote')) {
                    $.ajax({
                        url: voteUrl,
                        type: 'post',
                        data: {
                            'question_id': $btn.data('id')
                        }
                    }).done(
                        /**
                         * Обработка результата запроса на добавление голоса
                         * @param {Object} result - результат запроса
                         * @param {Object} result.vote - резултат голосования
                         */
                        function (result) {
                            $btn.attr('data-user-vote', result.vote).blur();
                            var $voteCount = $btn.siblings('.js-question-vote-count');
                            var voteNumber = parseInt($voteCount.text(), 10);
                            var newText = (voteNumber + 1) + ' ' + pluralize(voteNumber + 1, {
                                one: 'голос',
                                few: 'голоса',
                                many: 'голосов'
                            });
                            $voteCount.text(newText);
                        }
                    ).fail(function (err) {
                        console.log('Не удалось проголосовать', err);
                    });
                }
            });

            // Клик по ссылке в пагинации
            $(document).on('click', '.pagination a', function (e) {
                e.preventDefault();
                var $link = $(this);
                var page = parseInt($link.data('page'));
                goToPage(page);
            });
        }

        init();

        return this;
    };
})(jQuery);
